__turbopack_context__.v({
  "transferBonus": "transfer-bonus-module-scss-module__cnfgNq__transferBonus",
  "transferBonus__open": "transfer-bonus-module-scss-module__cnfgNq__transferBonus__open",
  "transferBonus__tooltip": "transfer-bonus-module-scss-module__cnfgNq__transferBonus__tooltip",
});
